import React, {useEffect, useState} from 'react'
import {Dispatch} from 'redux'
import {Loader} from '../../../services/Loader'
import {shallowEqual, useDispatch, useSelector} from 'react-redux'
import {RootState} from '../../../../setup'
import {
  AuthFooter,
  formattedPhoneNumber,
  handleNotificationWithToastify,
  isCompanyGracePeriodExpired,
  maskEmail,
  maskPhoneNumber,
  redirectToLoginPaymentIfRequired,
  resolveProductionLoginCompanyGate,
} from '../../../services/Functional'
import {getUserDisplayEmail} from '../../../services/userEmailDisplay'
import {
  getInspectionCompanies,
  getUserAccess,
  handleExpiredCompany,
  handleIsExpiredCompanyAPIcalling,
  handleIsInOTPPage,
  handleSetWorkspaceAuth,
  handleTemporaryPassword,
  hydrateWorkspaceAuth,
  resendOTP,
  selectWorkspace,
  verifyOTP,
  checkSubscriptionExpiry,
} from '../../../../setup/redux/auth/actions'
import {getOtpFallbackExplanation, shouldShowEmailToSmsFallbackNotice} from '../otpDeliveryMessages'
import {Link, useNavigate} from 'react-router-dom'
import {AuthSidePanel} from './AuthSidePanel'
import {CustomOtpInput} from './otpinput/CustomOtpInput'
import {ResendOTP} from './resendotp/ResendOtp'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'

interface Payload {
  mobile_no?: string
  email?: string
  mode: 'mobile' | 'email'
  is_login_2fa?: boolean
}

export function Otp() {
  const dispatch: Dispatch<any> = useDispatch()
  const navigate = useNavigate()
  const [loading, setLoading] = useState<boolean>(false)
  const [hasErrors, setHasErrors] = useState<boolean>(false)
  const [otp, setOTP] = React.useState('')

  const {
    config,
    user,
    subscription_renew_check,
    mode,
    active_inspection_company,
    otpDelivery,
    pickerToken,
    workspaces,
  }: any = useSelector<RootState>(
    (state) => ({
      config: state.configuration.configurations,
      user: state.auth.user,
      mode: state.auth.mode,
      access_token: state.auth.access_token,
      subscription_renew_check: state.auth.subscription_renew_check,
      active_inspection_company: state.auth.active_inspection_company,
      otpDelivery: state.auth.otpDelivery,
      pickerToken: state.auth.picker_token,
      workspaces: state.auth.workspaces,
    }),
    shallowEqual
  )

  const effectiveActualChannel = otpDelivery?.actualChannel ?? (mode === 'mobile' ? 'sms' : 'email')

  const fallbackExplanation =
    shouldShowEmailToSmsFallbackNotice(otpDelivery) && otpDelivery?.fallbackReason
      ? getOtpFallbackExplanation(otpDelivery.fallbackReason)
      : null

  let values: Payload

  if (mode === 'mobile') {
    values = {
      mobile_no: formattedPhoneNumber(user?.country_code, user?.phone),
      mode: 'mobile',
      is_login_2fa: true,
    }
  } else {
    values = {
      email: getUserDisplayEmail(user),
      mode: 'email',
      is_login_2fa: true,
    }
  }

  const handleOTPChange = (otp: string) => {
    setOTP(otp)
  }

  // useEffect(() => {
  //   if (access_token && inspectionCompanies && inspectionCompanies.length > 0) {
  //     if (inspectionCompanies?.length > 1) {
  //       navigate('/company-select')
  //     } else {
  //       navigate('/dashboard')
  //     }
  //   }
  // }, [user, inspectionCompanies])

  useEffect(() => {
    if (subscription_renew_check && subscription_renew_check <= 0) {
      const gracePeriodExpiredComapny = isCompanyGracePeriodExpired(active_inspection_company)
      if (gracePeriodExpiredComapny) {
        navigate('/logout')
      }
    }
  }, [subscription_renew_check])

  const handleOTPSubmit = async () => {
    if (otp.length === 6) {
      setLoading(true)
      const response: any = await dispatch(verifyOTP({id: user?.sub || user?.id, otp}))
      if (response?.success) {
        setHasErrors(false)
        localStorage.setItem('otpRemainingTime', '30')
        localStorage.setItem('otpResendCount', '0')
        localStorage.setItem('otpMaxResendCount', '3')
        dispatch(handleIsInOTPPage(false))
        dispatch(handleTemporaryPassword(undefined))

        if (pickerToken && workspaces?.length > 0) {
          if (workspaces.length === 1) {
            const ws = workspaces[0]
            const selectResp: any = await dispatch(selectWorkspace(ws.membership_id, pickerToken))
            if (redirectToLoginPaymentIfRequired(selectResp?.data)) {
              setLoading(false)
              return
            }
            if (!selectResp?.data?.success || !selectResp?.data?.data) {
              setLoading(false)
              setHasErrors(true)
              handleNotificationWithToastify({
                success: false,
                message: selectResp?.data?.message || 'Failed to select workspace',
              })
              return
            }
            const hydrated = hydrateWorkspaceAuth(selectResp.data.data, user)
            dispatch(handleSetWorkspaceAuth(hydrated))
            const accessResult: any = await dispatch(getUserAccess())
            if (!accessResult?.success) {
              setLoading(false)
              handleNotificationWithToastify({
                success: false,
                message: accessResult?.message || 'Unable to load permissions.',
              })
              return
            }
            const companiesResp: any = await dispatch(
              getInspectionCompanies(hydrated.active_inspection_company?.id)
            )
            const allCompanies = companiesResp?.data?.data?.inspection_companies
            const activeCompany =
              allCompanies?.find((c: any) => c.id === hydrated.active_inspection_company?.id) ||
              hydrated.active_inspection_company

            if (redirectToLoginPaymentIfRequired(null, activeCompany)) {
              setLoading(false)
              return
            }

            if (!hydrated.user?.is_root) {
              const groupIds = (activeCompany?.groups || []).map((group: any) => group.slug)
              if (!groupIds.includes('company-admins')) {
                setLoading(false)
                navigate('/error/auth')
                return
              }

              const expiryData: any = await dispatch(
                checkSubscriptionExpiry(activeCompany.id)
              )
              const gate = resolveProductionLoginCompanyGate(activeCompany, {
                expiryData: expiryData?.data,
              })

              if (gate.action === 'redirect') {
                setLoading(false)
                window.location.href = gate.url
                return
              }
              if (gate.action === 'access_denied') {
                setLoading(false)
                dispatch(handleIsExpiredCompanyAPIcalling(true))
                dispatch(handleExpiredCompany(gate.company))
                navigate('/error/access-denied')
                return
              }
              if (gate.action === 'error') {
                setLoading(false)
                setHasErrors(true)
                handleNotificationWithToastify({
                  success: false,
                  message: gate.message,
                })
                return
              }
            }

            setLoading(false)
            if (hydrated.user?.is_root === true && (allCompanies?.length ?? 0) > 1) {
              navigate('/company-select')
            } else {
              navigate('/dashboard')
            }
          } else {
            setLoading(false)
            navigate('/company-select')
          }
        } else {
          setLoading(false)
          navigate('/auth/login')
        }
      } else {
        setLoading(false)
        setHasErrors(true)
        handleNotificationWithToastify(response)
        setTimeout(() => {
          setHasErrors(false)
          setOTP('')
        }, 5000)
      }
    }
  }

  const handleBackButton = () => {
    navigate('/auth/login', {replace: true})
  }

  return (
    <>
      {loading && <Loader />}
      <div className='row w-100 h-100 p-0 m-0'>
        <div className='col-md-7 p-0 bg-white position-relative'>
          <div className='py-5 d-flex justify-content-between container align-items-center mb-8'>
            <img src={config && config?.actual_logo} alt='logo' width={90} />
            <Link
              to='https://decenthands.com/contact'
              className='link-primary fs-6 float-end'
              target='_blank'
            >
              Contact Us
            </Link>
          </div>
          <div className='auth_form_container mx-auto d-flex justify-content-center align-items-center h-100'>
            <div className='h-100 otp_page_container'>
              <div className={`mb-5 animate__animated animate__fadeInUp`}>
                <h2 className='font-weight-bold otp_header'>Enter Verification Code</h2>
              </div>
              {fallbackExplanation ? (
                <div
                  className='mb-3 d-flex align-items-start gap-2 small animate__animated animate__fadeInUp text-body-secondary'
                  role='status'
                >
                  <i
                    className='bi bi-exclamation-triangle-fill text-warning flex-shrink-0 mt-1'
                    aria-hidden
                  />
                  <span>{fallbackExplanation}</span>
                </div>
              ) : null}
              <div className='mb-5 otp_sub_header animate__animated animate__fadeInUp'>
                Enter the 6-digit code sent to{' '}
                <OverlayTrigger
                  key='show'
                  placement='top'
                  overlay={
                    <Tooltip id='show'>
                      {effectiveActualChannel === 'sms'
                        ? maskPhoneNumber(user?.phone, user?.country_code)
                        : maskEmail(getUserDisplayEmail(user))}
                    </Tooltip>
                  }
                >
                  <span className='mask-otp-text'>
                    {effectiveActualChannel === 'sms'
                      ? maskPhoneNumber(user?.phone, user?.country_code)
                      : maskEmail(getUserDisplayEmail(user))}
                  </span>
                </OverlayTrigger>
              </div>
              <div className='mb-5'>
                <CustomOtpInput
                  label='otp'
                  otp={otp}
                  error={hasErrors}
                  handleOTPChange={handleOTPChange}
                  onEnterPress={handleOTPSubmit}
                  enableEnterKeySubmit={true}
                  className='otp_page_input animate__animated animate__fadeInUp'
                  separatorClassName='separator'
                />
              </div>
              <div className='mb-5'>
                <ResendOTP
                  className='animate__animated animate__fadeInUp'
                  APICalled={resendOTP(values)}
                  handleBackButton={handleBackButton}
                  showBackBtn={true}
                />
              </div>
              <button
                type='submit'
                disabled={otp.length < 6}
                tabIndex={3}
                onClick={handleOTPSubmit}
                className={`btn btn-primary btn-pill animate__animated animate__fadeInUp w-100 ${otp.length < 6 && 'disable-otp-btn'}`}
              >
                Verify & Sign In
                <img
                  className='ms-3'
                  src={'/media/icons/duotune/general/Arrow - Right.svg'}
                  alt='->'
                />
              </button>
            </div>
            <AuthFooter />
          </div>
        </div>
        <div className='col-md-5 p-0 background_card overflow-hidden position-relative'>
          <AuthSidePanel />
        </div>
      </div>
    </>
  )
}
